import * as React from 'react';
import Utils from '../../utils';
import { LoaderVariants } from './styles';
import { Progress } from '../../containers/DownloadManager/reducer';

const Translate = require('react-redux-i18n').Translate;

export enum LoaderStepName {
	Creating = 'Creating',
	Downloading = 'Downloading',
	DownloadingDependecies = 'DownloadingDependecies',
	DownloadingAll = 'DownloadingAll',
	LoggingIn = 'LoggingIn'
}

export interface LoggingInStep {
	step: LoaderStepName.LoggingIn;
}

export interface CreatingStep {
	step: LoaderStepName.Creating;
}

export interface DownloadingStep {
	step: LoaderStepName.Downloading;
	progress?: Progress;
}

export interface DownloadingDependeciesStep {
	step: LoaderStepName.DownloadingDependecies;
	dependenciesDownloaded: number;
	dependenciesToDownload: number;
}

export interface DownloadingAllStep {
	step: LoaderStepName.DownloadingAll;
	itemsDownloaded: number;
	itemsToDownload: number;
}

export enum LoaderType {
	Button = 'Button',
	Overlay = 'Overlay'
}

export type LoaderStep = DownloadingStep | DownloadingDependeciesStep | DownloadingAllStep | CreatingStep | LoggingInStep;

export interface LoaderProps {
	loaderStep: LoaderStep;
	type: LoaderType;
}

const Loader = (props: LoaderProps) => {
	const { loaderStep, type } = props;
	const StyledLoader = LoaderVariants[type];
	const isDownloadingAll = loaderStep.step === LoaderStepName.DownloadingAll;

	return (
		<StyledLoader isDownloadingAll={isDownloadingAll}>
			{Utils.getSvgIcon('iconset_loading')}
			{getLoadingMessage(loaderStep)}
		</StyledLoader>
	);
};

const getLoadingMessage = (loaderStep: LoaderStep) => {
	switch (loaderStep.step) {
		case LoaderStepName.Downloading:
			const { progress } = loaderStep;
			return [
				<Translate key="loading" value="messages.loading" />,
				progress && progress.loaded && progress.totalSize && !!+progress.totalSize && `${Math.floor(progress.loaded * 100 / progress.totalSize)}%`,
			];
		case LoaderStepName.DownloadingDependecies:
			const { dependenciesDownloaded, dependenciesToDownload } = loaderStep;
			return (
				<Translate
					value={dependenciesToDownload < 2 ? 'messages.dependency_downloaded_out_of' : 'messages.dependencies_downloaded_out_of'}
					dependenciesDownloaded={dependenciesDownloaded}
					dependenciesToDownload={dependenciesToDownload}
				/>
			);
		case LoaderStepName.DownloadingAll:
			const { itemsDownloaded, itemsToDownload } = loaderStep;
			return (
				<Translate
					value={itemsToDownload < 2 ? 'messages.item_downloaded_out_of' : 'messages.items_downloaded_out_of'}
					itemsDownloaded={itemsDownloaded}
					itemsToDownload={itemsToDownload}
				/>
			);
		case LoaderStepName.Creating:
			return <Translate value="messages.create_demo_account" />;
		case LoaderStepName.LoggingIn:
			return <Translate value="messages.logging_in" />;
		default:
			return;
	}
};

export default Loader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Loader/index.tsx